export default "__VITE_ASSET__BD21mqDl__"